<div class="card" *blockUI="'section-block'">
    <div class="row mt-1">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-start align-items-center">
                <button class="btn btn-info ml-1" rippleEffect (click)="createWorker()"
                    *ngIf="authService.isEndpointStatus('POST.Writing.CreateWorker')">
                    <i data-feather="plus" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
                        class="d-none d-sm-inline-block">Çalışan Ekle </span>
                </button>
                <div class="ml-3" *ngIf="authService.isEndpointStatus('POST.Writing.CreateExcelPersons')">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" [checked]="isAdvancedChange"
                        (change)="toggleAdvancedUpload($event)" />
                    <label class="custom-control-label" for="customCheck1">Excel ile yükleme</label>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div class="form-group col-md-3 col-sm-12">
                <ng-select [items]="statusList" name="selectedRole" bindLabel="title" bindValue="id" placeholder="Durum"
                    (change)="filterByStatus($event)" [(ngModel)]="status" [clearable]="false">
                </ng-select>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-1">
                <label class="d-flex align-items-center">
                    <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
            <div class="col-6">
                <label class="d-flex align-items-center">
                    <input type="search" placeholder="Bul" class="form-control ml-25" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" />
                </label>
            </div>
            <div ngbDropdown [placement]="'left'" class="btn-group dropup dropdown-icon-wrapper mb-1">
                <button ngbDropdownToggle type="button" class="btn btn-icon btn-flat-primary dropdown-toggle-split"
                    rippleEffect>
                    <span [data-feather]="'more-vertical'" class="'dropdown-icon'"></span>
                </button>
                <div ngbDropdownMenu>
                    <span ngbDropdownItem (click)="exportAsExcelFile()">Excel'e Aktar</span>
                </div>
            </div>
        </div>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true" (activate)="onActivate($event)">
        <ngx-datatable-column name="İşe Başlama Tarihi" [width]="100">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.startDate | date:'dd.MM.yyyy' }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="TC" prop="tc" [width]="100"></ngx-datatable-column>
        <ngx-datatable-column name="Sicil No" prop="registrationNumber" [width]="100"></ngx-datatable-column>

        <ngx-datatable-column name="ISIM SOYISIM" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.name}} {{row.lastName}}
            </ng-template>
        </ngx-datatable-column>

        <!-- <ngx-datatable-column name="Firma Adı">
            <ng-template ngx-datatable-cell-template let-row="row">
                <a href="#/admin/company/{{ row.companyId }}" [ngbTooltip]="row?.companyName" container="body"
                    placement="top">{{row.companyName | slice:0:20}}{{ row.companyName.length > 20 ? '...' : '' }}</a>
            </ng-template>
        </ngx-datatable-column> -->
        <ngx-datatable-column name="Görev" prop="mission" [width]="100"></ngx-datatable-column>
        <ngx-datatable-column name="Departman" prop="department" [width]="100"></ngx-datatable-column>
        <ngx-datatable-column name="Tel No" prop="phoneNumber" [width]="50"></ngx-datatable-column>
        <ngx-datatable-column name="Çalışma Durumu" [width]="100">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="badge badge-pill" [ngClass]="row.workingStatus ? 'badge-success' : 'badge-danger'">
                    {{row.workingStatus ? "Aktif" : "Pasif"}}</div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="#" [width]="50" [sortable]="false"
            *ngIf="authService.isEndpointStatus('DELETE.Deleteing.RemovePerson')">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">

                    <!-- <a href="#/admin/update-worker/{{row.id}}">
                        <button class="btn btn-icon btn-flat-info" *ngIf="row.companyId == 1">
                            <span [data-feather]="'edit'"></span>
                        </button>
                    </a>

                    <button class="btn btn-icon btn-flat-warning" (click)="updatePerson(row.id,row.companyId)"
                        *ngIf="row.companyId != 1">
                        <span [data-feather]="'edit'"></span>
                    </button> -->

                    <button class="btn btn-icon btn-flat-danger" appDelete controller="persons" [id]="row.id"
                        (callback)="getAllPerson(0,5,'')" (click)="handleDelete($event)">
                        <span [data-feather]="'trash'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>

<div *ngIf="isAdvancedChange" class="card mt-2">
    <div class="form-group">
        <div class="col-12 d-flex justify-content-between">
            <div class="col-4">
                <label for="basicInputFile">Ürün Yükle</label>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" id="customFile" (change)="onFileChange($event)"
                        accept=".xlsx, .xls" #fileInput />
                    <label class="custom-file-label" for="customFile">Excel dosyası seçiniz</label>
                </div>
            </div>
            <div class="col-4 mt-2 d-flex justify-content-between">
                <button type="button" class="btn btn-outline-danger" rippleEffect
                    (click)="resetFileInput(fileInput)">Dosyayı sil</button>

                <a href="assets/excels/personeller.xlsx" download="Personel_Listesi_Şablonu.xlsx"
                    class="btn btn-outline-info" rippleEffect>
                    <span [data-feather]="'arrow-down'" [class]="'mr-25'"></span>
                    Şablon
                </a>
            </div>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Adı</th>
                    <th>Soyadı</th>
                    <th>Mail</th>
                    <th>Tel No</th>
                    <th>Görev</th>
                    <th>Departman</th>
                    <th>TC</th>
                    <th>Çalışıyor mu?</th>
                    <th>Maaş</th>
                    <th>Doğum Tarihi</th>
                    <th>Acil Durum Kontoağı</th>
                    <th>Adres</th>
                    <th>İşe Başlama Tarihi</th>
                    <th>Sicil No</th>
                    <th>Çalışma Günleri</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of personExcel; let i = index">
                    <td> {{i + 1}} </td>
                    <td> {{item.name}} </td>
                    <td> {{item.lastName}} </td>
                    <td> {{item.mail}} </td>
                    <td> {{item.phoneNumber}} </td>
                    <td> {{item.Mission}} </td>
                    <td> {{item.Depertmant}} </td>
                    <td> {{item.Tc}} </td>
                    <td> {{item.workingStatus}} </td>
                    <td> {{item.wage}} </td>
                    <td> {{ item.birthDay | date:'dd.MM.yyyy' }} </td>
                    <td> {{ item.emergenyContact }} </td>
                    <td> {{ item.address }} </td>
                    <td> {{ item.startDate | date:'dd.MM.yyyy' }} </td>
                    <td> {{ item.registrationNumber }} </td>
                    <td> {{ item.workingDays }} </td>
                </tr>
            </tbody>
        </table>

        <button type="button" class="btn btn-success d-flex ml-1 mt-2 mb-2" rippleEffect
            [disabled]="!isPersonsValid || !allPersonsValid" (click)="saveProducts()">Kaydet</button>
    </div>
</div>